import { useState, useEffect } from 'react';
import { bookingRepository } from '../../../domain/bookingRepository';

export const useBookingPost = (isSending, formData) => {
    const [bookingPostResult, setBookingPostResult] = useState([]);

    useEffect(() => {
        if (isSending && formData) {
            console.log(`useBookingPost formData.paymentScreenshot.name: ${formData.get('paymentScreenshot').name}`)
            console.log(`useBookingPost formData.eventType: ${formData.get('eventType')}`)
            bookingRepository.postBooking(formData)
            .then((result) => {
                setBookingPostResult(result)
            })
            .catch((err) => {
                console.error("Failed to post booking:", err)
            });
        }
    }, [isSending, formData]);

    return bookingPostResult;
};